(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haksam-elegant-fit"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialiseVideos(scope) {
    scope.querySelectorAll('[data-haksam-elegant-video] video').forEach((video) => {
      if (video.dataset.elegantInitialised) return;
      video.dataset.elegantInitialised = 'true';
      video.muted = true;
      video.defaultMuted = true;
      let visible = false;
      const update = () => {
        if (visible && !document.hidden) {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } else {
          video.pause();
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          update();
        }, { threshold: [0, 0.2] });
        observer.observe(video);
      } else {
        const bounds = video.getBoundingClientRect();
        visible = bounds.bottom > 0 && bounds.top < window.innerHeight;
        update();
      }
      document.addEventListener('visibilitychange', update);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseVideos(document), { once: true });
  } else {
    initialiseVideos(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialiseVideos(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haksam-fits-inside"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeFitsVideos(scope) {
    scope.querySelectorAll('[data-haksam-fits-video] video').forEach((video) => {
      if (video.dataset.fitsInitialized) return;
      video.dataset.fitsInitialized = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.pause();
      let inView = false;
      const updatePlayback = () => {
        if (inView && !document.hidden) {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } else {
          video.pause();
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          updatePlayback();
        }, { threshold: [0, 0.2] });
        observer.observe(video);
      } else {
        const bounds = video.getBoundingClientRect();
        inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
        updatePlayback();
      }
      document.addEventListener('visibilitychange', updatePlayback);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFitsVideos(document), { once: true });
  } else {
    initializeFitsVideos(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeFitsVideos(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
